import TableActionButtonDelete from './TableActionButtonDelete';

export default TableActionButtonDelete;
